export interface Movie {
  id: string;
  title: string;
  category: string;
  year: number;
  rating: number;
  image: string;
  description: string;
  director: string;
  actors: string[];
  duration: string;
  region: string;
  type: string;
  updateDate: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-function-line' },
  { slug: 'movie', name: '电影', icon: 'ri-film-line' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-mic-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-emotion-line' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-camera-line' },
];

export const movies: Movie[] = [
  {
    id: 'movie-001',
    title: '流浪地球3',
    category: 'movie',
    year: 2026,
    rating: 8.5,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%2C%20sci-fi%20space%20theme%20with%20astronauts%20and%20giant%20planet%20in%20background%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20deep%20black%20contrast%2C%20epic%20scale%2C%20professional%20film%20poster%20design%2C%20clean%20composition%2C%20no%20text&width=800&height=1120&seq=movie-001&orientation=portrait',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，一群勇敢的年轻人挺身而出，为了全人类的未来而战。这是流浪地球系列的第三部作品，延续了宏大的科幻设定与深刻的人性思考。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    duration: '148分钟',
    region: '中国大陆',
    type: '科幻 / 冒险 / 灾难',
    updateDate: '2026-07-28',
    tags: ['科幻大片', '国产巨制', 'IMAX'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'movie-002',
    title: '满江红',
    category: 'movie',
    year: 2025,
    rating: 7.8,
    image: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20movie%20poster%2C%20ancient%20Chinese%20warriors%20in%20red%20and%20black%20armor%2C%20dramatic%20candlelight%20atmosphere%2C%20dark%20moody%20background%2C%20cinematic%20composition%2C%20professional%20film%20poster%20design%2C%20no%20text&width=800&height=1120&seq=movie-002&orientation=portrait',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这场巨大阴谋之中。',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    duration: '159分钟',
    region: '中国大陆',
    type: '剧情 / 喜剧 / 悬疑',
    updateDate: '2026-07-25',
    tags: ['悬疑', '历史', '口碑佳作'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-003',
    title: '速度与激情11',
    category: 'movie',
    year: 2026,
    rating: 7.2,
    image: 'https://readdy.ai/api/search-image?query=Action%20movie%20poster%20with%20fast%20sports%20cars%20on%20fire%2C%20explosive%20urban%20street%20scene%2C%20intense%20orange%20and%20red%20flames%2C%20dynamic%20motion%20blur%2C%20professional%20film%20poster%20design%2C%20dark%20background%2C%20no%20text&width=800&height=1120&seq=movie-003&orientation=portrait',
    description: '多米尼克·托雷托和他的家人们面临迄今为止最危险的敌人。一个从过去阴影中浮现的致命威胁，迫使唐老大面对他曾犯下的罪孽，为了守护所爱之人，他必须集结最强大的团队。',
    director: '路易斯·莱特里尔',
    actors: ['范·迪塞尔', '杰森·斯坦森', '道恩·强森'],
    duration: '142分钟',
    region: '美国',
    type: '动作 / 犯罪 / 冒险',
    updateDate: '2026-07-20',
    tags: ['动作', '飙车', '好莱坞'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'movie-004',
    title: '长安三万里2',
    category: 'anime',
    year: 2026,
    rating: 8.8,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%2C%20ancient%20Tang%20dynasty%20style%2C%20poetic%20landscape%20with%20mountains%20and%20rivers%2C%20warm%20golden%20sunset%20light%2C%20traditional%20Chinese%20ink%20painting%20aesthetic%2C%20cinematic%20composition%2C%20no%20text&width=800&height=1120&seq=movie-004&orientation=portrait',
    description: '安史之乱后，长安城满目疮痍。高适与李白再度相遇，两人在乱世中追寻各自的理想与抱负。本片延续第一部的诗意画风，以更宏大的视角展现盛唐文人的家国情怀与人生抉择。',
    director: '谢君伟',
    actors: ['杨天翔', '凌振赫', '赵铭洲'],
    duration: '168分钟',
    region: '中国大陆',
    type: '动画 / 历史 / 诗歌',
    updateDate: '2026-07-15',
    tags: ['国产动漫', '历史', '高分'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'tv-001',
    title: '庆余年 第二季',
    category: 'tv',
    year: 2026,
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20TV%20drama%20poster%2C%20ancient%20Chinese%20nobleman%20in%20elegant%20robes%2C%20dramatic%20palace%20setting%2C%20warm%20golden%20and%20deep%20red%20color%20palette%2C%20cinematic%20composition%2C%20professional%20drama%20poster%2C%20no%20text&width=800&height=1120&seq=tv-001&orientation=portrait',
    description: '范闲在经历了一系列危机后，终于在北齐完成了使命回到庆国。然而朝堂之上的权力斗争愈发激烈，范闲不得不在各方势力之间周旋，同时揭开自己身世之谜的真相。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    duration: '45分钟/集 共36集',
    region: '中国大陆',
    type: '古装 / 权谋 / 奇幻',
    updateDate: '2026-08-01',
    tags: ['热播', '古装', '权谋'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'tv-002',
    title: '繁花',
    category: 'tv',
    year: 2025,
    rating: 8.7,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%2C%201990s%20Shanghai%20nostalgic%20atmosphere%2C%20elegant%20people%20in%20vintage%20clothing%2C%20warm%20neon%20lights%2C%20cinematic%20golden%20hour%20lighting%2C%20professional%20TV%20drama%20poster%2C%20no%20text&width=800&height=1120&seq=tv-002&orientation=portrait',
    description: '九十年代的上海，机遇与挑战并存。阿宝凭借自己的智慧和勇气，在商海中闯出一片天地。本剧以独特的视觉美学，展现了大时代下小人物的奋斗与情感。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    duration: '50分钟/集 共30集',
    region: '中国大陆',
    type: '剧情 / 爱情 / 年代',
    updateDate: '2026-07-22',
    tags: ['口碑', '年代剧', '王家卫'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'variety-001',
    title: '奔跑吧 第十二季',
    category: 'variety',
    year: 2026,
    rating: 7.6,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20celebrities%20running%20and%20laughing%2C%20bright%20colorful%20outdoor%20scene%2C%20energetic%20happy%20vibe%2C%20professional%20entertainment%20poster%2C%20vibrant%20colors%2C%20no%20text&width=800&height=1120&seq=variety-001&orientation=portrait',
    description: '全新一季奔跑吧重磅回归！常驻MC阵容升级，全新游戏玩法升级。在欢笑与挑战中，跑男团将走遍全国各地，为观众带来无限的欢乐与感动。',
    director: '姚译添',
    actors: ['李晨', '郑恺', '杨颖', '白鹿', '周深'],
    duration: '90分钟/期',
    region: '中国大陆',
    type: '真人秀 / 竞技 / 搞笑',
    updateDate: '2026-08-01',
    tags: ['综艺', '真人秀', '热门'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'doc-001',
    title: '地球脉动 第三季',
    category: 'documentary',
    year: 2026,
    rating: 9.5,
    image: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%2C%20stunning%20wildlife%20photography%20of%20animals%20in%20their%20natural%20habitat%2C%20dramatic%20landscape%20with%20mountains%20and%20oceans%2C%20professional%20BBC%20style%20documentary%20poster%2C%20no%20text&width=800&height=1120&seq=doc-001&orientation=portrait',
    description: 'BBC史诗级自然纪录片回归！历时五年拍摄，横跨六大洲四十三个国家，用最先进的拍摄技术记录地球最壮丽的自然奇观和最动人的生命故事。',
    director: 'BBC Studios',
    actors: ['大卫·爱登堡'],
    duration: '60分钟/集 共8集',
    region: '英国',
    type: '自然 / 纪录 / 探索',
    updateDate: '2026-07-10',
    tags: ['BBC', '自然', '高分纪录'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'anime-001',
    title: '鬼灭之刃 柱训练篇',
    category: 'anime',
    year: 2026,
    rating: 8.6,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20style%2C%20demon%20slayer%20warrior%20with%20katana%20sword%2C%20dynamic%20action%20pose%2C%20dark%20atmospheric%20background%20with%20flames%2C%20professional%20anime%20key%20visual%2C%20vibrant%20color%20contrast%2C%20no%20text&width=800&height=1120&seq=anime-001&orientation=portrait',
    description: '炭治郎一行人开始了与柱们的高强度训练。在严酷的修行中，他们不断突破自身极限，为即将到来的最终决战做准备。本季将展现鬼杀队最强剑士们的惊人实力。',
    director: '外崎春雄',
    actors: ['花江夏树', '鬼头明里', '下野纮'],
    duration: '24分钟/集 共8集',
    region: '日本',
    type: '动画 / 动作 / 奇幻',
    updateDate: '2026-07-18',
    tags: ['日漫', '热血', '高人气'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'movie-005',
    title: '热辣滚烫2',
    category: 'movie',
    year: 2026,
    rating: 7.9,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%2C%20woman%20boxing%20training%20in%20a%20gym%2C%20determined%20expression%2C%20warm%20motivational%20atmosphere%2C%20soft%20dramatic%20lighting%2C%20professional%20film%20poster%2C%20no%20text&width=800&height=1120&seq=movie-005&orientation=portrait',
    description: '乐莹在经历了人生的起落后，重新找到了自己的方向。她开了一家小小的拳击馆，帮助更多和她一样在生活中迷失的人找到自我。生活不止有拳头，更有温暖与希望。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐', '杨紫'],
    duration: '135分钟',
    region: '中国大陆',
    type: '剧情 / 喜剧 / 励志',
    updateDate: '2026-07-08',
    tags: ['励志', '喜剧', '女性'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'tv-003',
    title: '三体：大史传',
    category: 'tv',
    year: 2026,
    rating: 8.3,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20TV%20drama%20poster%2C%20mysterious%20cosmic%20phenomenon%20in%20the%20sky%2C%20futuristic%20yet%20grounded%20aesthetic%2C%20dark%20blue%20and%20silver%20color%20scheme%2C%20professional%20drama%20poster%2C%20no%20text&width=800&height=1120&seq=tv-003&orientation=portrait',
    description: '以警官大史为主角视角，讲述在三体危机爆发前，他如何凭借敏锐的直觉与丰富的刑侦经验，一步步接近真相。本剧将揭开三体世界中更多不为人知的秘密。',
    director: '杨磊',
    actors: ['于和伟', '张鲁一', '陈瑾', '王子文'],
    duration: '50分钟/集 共24集',
    region: '中国大陆',
    type: '科幻 / 悬疑 / 剧情',
    updateDate: '2026-07-30',
    tags: ['科幻', '三体', '悬疑'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'variety-002',
    title: '歌手2026',
    category: 'variety',
    year: 2026,
    rating: 8.0,
    image: 'https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%2C%20singer%20on%20stage%20with%20microphone%2C%20dramatic%20spotlight%20and%20stage%20effects%2C%20dark%20concert%20atmosphere%2C%20professional%20entertainment%20poster%2C%20glamorous%2C%20no%20text&width=800&height=1120&seq=variety-002&orientation=portrait',
    description: '华语乐坛顶级音乐竞演节目重磅回归！新一季集结两岸三地最具实力的歌手，通过震撼的现场Live表演，为观众带来极致的音乐盛宴。',
    director: '洪啸',
    actors: ['那英', '周深', '张杰', '邓紫棋', '华晨宇'],
    duration: '120分钟/期',
    region: '中国大陆',
    type: '音乐 / 竞演 / 真人秀',
    updateDate: '2026-08-02',
    tags: ['音乐', '竞演', '热门综艺'],
    isHot: true,
    isNew: true,
  },
];

export const articles = [
  {
    id: 'article-001',
    title: '2026暑期档电影大盘点：十部必看大片推荐',
    summary: '暑期档是每年电影市场的黄金时段，今年更是佳片云集。从国产科幻到好莱坞大片，我们为你精选了十部不容错过的暑期档电影。',
    content: `<p>每年暑期档都是电影市场的必争之地，2026年的暑期档更是精彩纷呈。从国产科幻巨制到好莱坞视觉盛宴，从感人至深的文艺片到令人捧腹的喜剧片，各类题材应有尽有。</p>
    <p>在国产片方面，《流浪地球3》无疑是今年暑期档最受瞩目的作品。郭帆导演再次将中国科幻电影推向新的高度，影片在视觉效果和故事深度上都达到了前所未有的水平。紧随其后的是《长安三万里2》，这部国产动画电影以其独特的诗意见长，将中国传统文化与现代动画技术完美融合。</p>
    <p>好莱坞方面，《速度与激情11》延续了这一经典系列的高燃风格，范·迪塞尔领衔的全明星阵容再次为观众带来极速狂飙的视觉冲击。此外还有多部优秀的独立电影值得关注。</p>
    <p>这个暑期，无论是想要在大银幕上感受科幻的震撼，还是想要在温馨的故事中获得感动，你都能找到适合自己的那部电影。快来春色影视，免费观看这些精彩大片吧！</p>`,
    category: 'movie',
    date: '2026-07-30',
    author: '春色影视编辑部',
    image: 'https://readdy.ai/api/search-image?query=Cinema%20movie%20theater%20interior%20with%20red%20seats%20and%20large%20screen%2C%20dramatic%20lighting%2C%20premium%20cinema%20experience%2C%20dark%20atmosphere%20with%20warm%20accent%20lighting%2C%20professional%20photography&width=1600&height=900&seq=article-001&orientation=landscape',
    tags: ['暑期档', '电影推荐', '观影指南'],
  },
  {
    id: 'article-002',
    title: '庆余年第二季为何能成为现象级爆款剧？',
    summary: '《庆余年》第二季自开播以来口碑与热度双丰收，豆瓣评分稳定在8.9分。本文深入分析这部剧成功背后的原因。',
    content: `<p>《庆余年》第二季在万众期待中回归，不负众望地成为2026年最火爆的电视剧之一。这部融合了权谋、武侠、科幻与喜剧元素的作品，究竟有何魔力？</p>
    <p>首先是演员阵容的强大。张若昀将范闲这个角色诠释得入木三分，陈道明、吴刚等老戏骨的加盟更是让整部剧的质感提升到了电影级别。每个角色都有自己的高光时刻，群像塑造堪称完美。</p>
    <p>其次是剧本的扎实。编剧王倦在原著基础上进行了合理的改编与创作，使得剧情更加紧凑，人物关系更加丰富。权谋线的层层递进让观众欲罢不能，而穿插其中的幽默元素又让整部剧不至于过于沉重。</p>
    <p>最后是制作的精良。从服化道到场景搭建，从动作设计到特效制作，《庆余年》第二季在每一个细节上都做到了极致。这样的品质，值得每一位观众细细品味。</p>`,
    category: 'tv',
    date: '2026-08-01',
    author: '春色影视编辑部',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20behind%20the%20scenes%2C%20ancient%20Chinese%20palace%20set%20design%2C%20elaborate%20costumes%20and%20props%2C%20professional%20film%20production%20photography%2C%20warm%20cinematic%20lighting&width=1600&height=900&seq=article-002&orientation=landscape',
    tags: ['庆余年', '剧评', '热播剧'],
  },
  {
    id: 'article-003',
    title: '国产动漫崛起之路：从长安三万里看国漫新高度',
    summary: '近年来国产动漫发展迅猛，《长安三万里》系列更是将国漫的艺术水准提升到了国际一流水平。让我们一起来回顾国漫的崛起之路。',
    content: `<p>十年前，提到优秀动画电影，人们首先想到的往往是日本或好莱坞的作品。而今天，国产动漫已经用一部又一部优秀作品证明了自己的实力。</p>
    <p>《长安三万里》系列是国漫崛起的重要里程碑。这部电影以盛唐为背景，通过高适与李白的故事，展现了中国传统文化的深厚底蕴。影片在画面表现上融合了中国水墨画的美学风格与现代3D技术，创造出独树一帜的视觉语言。</p>
    <p>从《大圣归来》到《哪吒之魔童降世》，从《白蛇：缘起》到《长安三万里》，国产动漫不仅在票房上屡创佳绩，更在艺术性和思想性上不断突破。这是中国动画人的骄傲，也是所有中国观众的骄傲。</p>`,
    category: 'anime',
    date: '2026-07-25',
    author: '春色影视编辑部',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20studio%20artists%20working%20on%20traditional%20ink%20painting%20style%20animation%2C%20creative%20workspace%2C%20warm%20lighting%2C%20professional%20creative%20environment&width=1600&height=900&seq=article-003&orientation=landscape',
    tags: ['国产动漫', '长安三万里', '国漫崛起'],
  },
  {
    id: 'article-004',
    title: '综艺节目新风向：2026年最值得追的五大综艺',
    summary: '综艺市场风云变幻，2026年有哪些综艺值得追？从音乐竞演到户外真人秀，我们为你梳理了今年的综艺风向。',
    content: `<p>综艺节目一直是观众茶余饭后的重要娱乐方式。2026年的综艺市场呈现出多元化发展的趋势，各种类型的节目百花齐放。</p>
    <p>音乐竞演类节目依然是流量担当。《歌手2026》集结了华语乐坛最强阵容，每一期都带来震撼的Live表演。而老牌综艺《奔跑吧》第十二季则在保持了原有欢乐氛围的同时，加入了更多创新玩法。</p>
    <p>慢综艺和观察类节目也越来越受到欢迎。这些节目通过真实记录明星的日常生活，让观众看到了他们接地气的一面，拉近了明星与观众之间的距离。</p>
    <p>不管是想要开怀大笑，还是想要被音乐感动，春色影视都为你准备了丰富的综艺内容，随时随地免费观看！</p>`,
    category: 'variety',
    date: '2026-07-28',
    author: '春色影视编辑部',
    image: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20production%20set%2C%20colorful%20studio%20with%20lights%20and%20cameras%2C%20entertainment%20production%20environment%2C%20professional%20broadcast%20studio&width=1600&height=900&seq=article-004&orientation=landscape',
    tags: ['综艺', '追综指南', '2026'],
  },
];

export const faqs = [
  { q: '春色影视最新网址是什么？', a: '春色影视最新网址会不定期更新以确保用户能够稳定访问。建议收藏本页面，我们会第一时间更新春色影视最新网址入口和官网新地址。您也可以通过搜索引擎搜索"春色影视最新网址"找到我们。' },
  { q: '春色影视是否需要注册或付费？', a: '春色影视完全免费，无需注册即可观看所有内容。我们致力于为广大影迷提供高清、流畅、免费的在线观影体验，没有任何隐藏收费。' },
  { q: '春色影视的影视资源更新频率如何？', a: '春色影视每日更新最新影视资源。热播剧集、热门电影、最新综艺都会在第一时间上线，确保用户能够看到最新的内容。' },
  { q: '观看时为什么会卡顿？如何解决？', a: '春色影视提供多条播放线路，如遇卡顿建议尝试切换播放线路或降低清晰度。同时确保您的网络环境稳定，建议使用Chrome、Edge等主流浏览器获得最佳观影体验。' },
  { q: '春色影视支持哪些设备观看？', a: '春色影视支持PC端、平板端和手机端观看。无论是在电脑、iPad还是手机上，都能获得流畅的高清观影体验。推荐使用手机浏览器访问以获得最佳移动端体验。' },
  { q: '春色影视的官网新地址在哪里可以找到？', a: '春色影视官网新地址会通过本站发布。如果当前网址无法访问，请收藏本页面以获取春色影视最新网址和官网新地址。我们建议关注我们的社交媒体账号以获取最新动态。' },
];

export const testimonials = [
  { name: '影迷小张', rating: 5, comment: '一直在用春色影视看电影，画质清晰还不卡顿，更新速度也很快，新片基本上隔天就能看到，太给力了！' },
  { name: '追剧达人', rating: 5, comment: '春色影视的电视剧资源真的很全，好多在其他平台要会员的剧这里都能免费看，清晰度还很高，强烈推荐！' },
  { name: '动漫爱好者', rating: 4, comment: '动漫资源很丰富，更新也很及时。界面简洁干净，没有乱七八糟的广告，观影体验非常棒。' },
  { name: '综艺控', rating: 5, comment: '周末必上春色影视看综艺，奔跑吧、歌手都有，更新速度杠杠的。高清不缓冲，用着特别舒心。' },
  { name: '电影发烧友', rating: 5, comment: '作为一个电影爱好者，春色影视满足了我所有的观影需求。国产大片、好莱坞巨制应有尽有，五星好评！' },
  { name: '家庭用户', rating: 4, comment: '一家老小都在用春色影视，老人看电视剧，孩子看动漫，我和老公看电影，一个平台全搞定，太方便了！' },
];